import Vue from "vue";
import VueI18n from "vue-i18n";
import "./Teaser.sass";
import createLang from "@/teaser_lang";
import findConfig from "@/lib/find-config";
import findEvents from "@/lib/find-events";
import EoTeaserCard from "@/components/TeaserCard/TeaserCard.vue";
import { replaceArrayWithWebContent } from "@/helpers/commonHelper";

Vue.use(VueI18n);
const i18n = createLang();

export default {
  name: "teaser",
  components: { EoTeaserCard },
  props: {
    id: {
      type: String,
      default: "eoev-teaser"
    },
    listUri: {
      type: String,
      required: true
    },
    targetUri: {
      type: String,
      required: true
    },
    locale: {
      type: String,
      default: "de-DE"
    },
    apiUrl: {
      type: String,
      required: true
    },
    apiKey: {
      type: String,
      required: true
    },
    initialSettings: Object,
    limit: {
      type: Number,
      default: 3
    },
    location: String,
    featureIds: Array,
    categoryIds: Array,
    highlight: Number,
    sorting: String,
    textColor: {
      type: String,
      default: "#333"
    }
  },
  data: () => ({
    isLoading: true, // initial load?
    widgetWidth: 0, // width of complete element
    events: [], // list of events
    settings: {},
    error: ""
  }),
  computed: {
    isMobile() {
      return this.widgetWidth < 600; // => https://vuetifyjs.com/de-DE/customization/breakpoints/
    },
    cols() {
      // calculate ideal columns
      const ideal = Math.floor(12 / (this.events && this.events.length) || 1);

      if (this.widgetWidth >= 1900) return Math.max(ideal, 2);
      if (this.widgetWidth >= 1260) return Math.max(ideal, 3);
      if (this.widgetWidth >= 960) return Math.max(ideal, 4);
      if (this.widgetWidth >= 600) return Math.max(ideal, 6);
      return 12;
    }
  },
  mounted() {
    this.widgetWidth = this.$refs.theWidget.offsetWidth;
  },
  async created() {
    // set locale globally
    this.$vuetify.lang.current = this.locale;

    // if no settings => get config from API!
    if (this.initialSettings) {
      this.settings = this.initialSettings;
    } else {
      await this.loadSettings();
    }

    // load matching events
    await this.loadData();

    // loading finished
    this.isLoading = false;

    // localization
    this.$i18n.locale = this.$vuetify.lang.current.substring(0, 2);
  },
  methods: {
    createQuery() {
      let sort = "moment";
      let direction = "asc";

      if (this.sorting) {
        const parts = this.sorting.split(":");

        if (parts.length > 0) sort = parts[0];
        if (parts.length > 1) direction = parts[1];
      }

      // define query
      const query = {
        limit: this.limit,
        active: this.settings.showReleased,
        hidden: 0,
        highlight: this.highlight,
        // highlight_to_top: this.settings.showHighlightToTop, // never do this in teasers!
        sort: sort,
        direction: direction,
        location: this.location,
        feature_ids: this.featureIds,
        category_ids: this.categoryIds
      };

      if (!query.highlight) {
        //never show not-highlights only
        delete query.highlight;
      }

      // take default offset for date, if set to other value than -1000
      if (this.settings.startDateDifference !== -1000) {
        // get date without tz offset
        const date = new Date();
        date.setMinutes(date.getMinutes() - date.getTimezoneOffset());

        // add number of days to set difference
        if (this.settings.startDateDifference !== 0) {
          date.setDate(date.getDate() + this.settings.startDateDifference);
        }

        // set start
        query.start = date.toISOString().substring(0, 10);
      }

      return query;
    },
    async loadData() {
      const query = this.createQuery();

      try {
        const data = await findEvents(this.apiUrl, this.apiKey, query, true);
        replaceArrayWithWebContent(data.results);
        this.events = data.results;
      } catch (e) {
        this.error = e;
      }
    },
    async loadSettings() {
      try {
        const data = await findConfig(this.apiUrl, this.apiKey);
        if (data && data.apiKeys && data.apiKeys.length) {
          this.settings = data.apiKeys[0]; // find first API key setting since this will be ours
        }
      } catch (e) {
        this.error = e;
      }
    },
    onResize() {
      this.widgetWidth = this.$refs.theWidget.offsetWidth;
    }
  },
  i18n
};
